/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { CreateM2MClientPage } from '@/pages/M2MClients/CreateM2MClientPage';

export function CreateM2MClientRoute() {
  return <CreateM2MClientPage />;
}
